export default __webpack_public_path__ + "static/logo_ogp-815652090dc3a3cd07d9000cf1dc4418.webp";